import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bordered-team-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["bordered-team", [{ 'is-full': _ctx.isFull }, { 'is-hidden-avatar': _ctx.hideAvatar }]])
  }, [
    _renderSlot(_ctx.$slots, "avatar", {}, () => [
      (!_ctx.hideAvatar)
        ? (_openBlock(), _createBlock(_component_Avatar, {
            key: 0,
            src: _ctx.src,
            type: "teamsGroup",
            size: "sm",
            bordered: ""
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isFull)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.teamName), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "after-name")
  ], 2))
}